import { useLoanDocument } from '../../hooks/useLoanDocument';

export function usePersonalGuaranteeDocument() {
  const {
    loanDocument,
    signLoanDocument,
    downloadLoanDocument,
    loanDocumentContent,
    isLoanDocumentSigned,
    isSigningLoanDocument,
    isLoadingLoanDocument,
  } = useLoanDocument('guarantee');

  return {
    personalGuaranteeDocument: loanDocument,
    downloadPersonalGuaranteeDocument: downloadLoanDocument,
    signPersonalGuaranteeDocument: signLoanDocument,
    personalGuaranteeContent: loanDocumentContent,
    isPersonalGuaranteeSigned: isLoanDocumentSigned,
    isSigningPersonalGuaranetee: isSigningLoanDocument,
    isLoadingPersonalGuarantee: isLoadingLoanDocument,
  };
}
